import kotlinx.browser.localStorage

class JsPlayerPreferences : PlayerPreferences {
    override fun getDice2DMode(): Boolean = localStorage.getItem("dice_2d_mode") == "true"
    override fun setDice2DMode(enabled: Boolean) {
        localStorage.setItem("dice_2d_mode", enabled.toString())
    }
    override fun getSeasonalEffectsEnabled(): Boolean = localStorage.getItem("seasonal_effects") != "false"
    override fun setSeasonalEffectsEnabled(enabled: Boolean) {
        localStorage.setItem("seasonal_effects", enabled.toString())
    }
    override fun getPlayerName(): String? = localStorage.getItem(KEY_NAME)

    override fun setPlayerName(name: String) {
        localStorage.setItem(KEY_NAME, name)
    }

    override fun getDynamicColorEnabled(): Boolean = localStorage.getItem(KEY_DYNAMIC_COLOR) == "true"

    override fun setDynamicColorEnabled(enabled: Boolean) {
        localStorage.setItem(KEY_DYNAMIC_COLOR, enabled.toString())
    }

    override fun getSelectedDiceSkin(): String? = localStorage.getItem(KEY_DICE_SKIN)

    override fun setSelectedDiceSkin(id: String) {
        localStorage.setItem(KEY_DICE_SKIN, id)
    }

    override fun getSelectedDiceHat(): String? = localStorage.getItem(KEY_DICE_HAT)

    override fun setSelectedDiceHat(id: String) {
        localStorage.setItem(KEY_DICE_HAT, id)
    }

    override fun getAchievementDiceUnlocked(): Boolean = localStorage.getItem(KEY_ACHIEVEMENT_DICE) == "true"

    override fun setAchievementDiceUnlocked(unlocked: Boolean) {
        localStorage.setItem(KEY_ACHIEVEMENT_DICE, unlocked.toString())
    }

    override fun getCreatorDiceUnlocked(): Boolean = localStorage.getItem(KEY_CREATOR_DICE) == "true"

    override fun setCreatorDiceUnlocked(unlocked: Boolean) {
        localStorage.setItem(KEY_CREATOR_DICE, unlocked.toString())
    }

    override fun getPracticeDiceUnlocked(): Boolean = localStorage.getItem(KEY_PRACTICE_DICE) == "true"

    override fun setPracticeDiceUnlocked(unlocked: Boolean) {
        localStorage.setItem(KEY_PRACTICE_DICE, unlocked.toString())
    }

    override fun getLimitedTimeDiceSkinUnlocks(): Set<String> =
        decodeLimitedTimeDiceSkinUnlocks(localStorage.getItem(KEY_LIMITED_TIME_DICE_SKINS))

    override fun setLimitedTimeDiceSkinUnlocks(ids: Set<String>) {
        localStorage.setItem(KEY_LIMITED_TIME_DICE_SKINS, encodeLimitedTimeDiceSkinUnlocks(ids))
    }

    override fun getAdsRemovedCached(): Boolean = localStorage.getItem(KEY_ADS_REMOVED) == "true"

    override fun setAdsRemovedCached(removed: Boolean) {
        localStorage.setItem(KEY_ADS_REMOVED, removed.toString())
    }

    override fun getHasCompletedFirstGame(): Boolean = localStorage.getItem(KEY_FIRST_GAME_DONE) == "true"

    override fun setHasCompletedFirstGame(completed: Boolean) {
        localStorage.setItem(KEY_FIRST_GAME_DONE, completed.toString())
    }

    override fun getPlusPassPending(): Boolean = localStorage.getItem(KEY_PLUS_PASS_PENDING) == "true"

    override fun setPlusPassPending(pending: Boolean) {
        localStorage.setItem(KEY_PLUS_PASS_PENDING, pending.toString())
    }

    override fun getDiceTrialSkinId(): String? = localStorage.getItem(KEY_DICE_TRIAL_SKIN)

    override fun setDiceTrialSkinId(id: String?) {
        if (id == null) localStorage.removeItem(KEY_DICE_TRIAL_SKIN) else localStorage.setItem(KEY_DICE_TRIAL_SKIN, id)
    }

    override fun getDiceTrialHatId(): String? = localStorage.getItem(KEY_DICE_TRIAL_HAT)

    override fun setDiceTrialHatId(id: String?) {
        if (id == null) localStorage.removeItem(KEY_DICE_TRIAL_HAT) else localStorage.setItem(KEY_DICE_TRIAL_HAT, id)
    }

    override fun getBankingHintShown(): Boolean = localStorage.getItem(KEY_BANKING_HINT) == "true"

    override fun setBankingHintShown(shown: Boolean) {
        localStorage.setItem(KEY_BANKING_HINT, shown.toString())
    }

    override fun getCareerStatsJson(): String? = localStorage.getItem(KEY_CAREER_STATS)

    override fun setCareerStatsJson(json: String?) {
        if (json == null) localStorage.removeItem(KEY_CAREER_STATS) else localStorage.setItem(KEY_CAREER_STATS, json)
    }

    private companion object {
        const val KEY_NAME = "player_name"
        const val KEY_DYNAMIC_COLOR = "dynamic_color"
        const val KEY_DICE_SKIN = "dice_skin"
        const val KEY_DICE_HAT = "dice_hat"
        const val KEY_ACHIEVEMENT_DICE = "achievement_dice_unlocked"
        const val KEY_CREATOR_DICE = "creator_dice_unlocked"
        const val KEY_PRACTICE_DICE = "practice_dice_unlocked"
        const val KEY_LIMITED_TIME_DICE_SKINS = "limited_time_dice_skins"
        const val KEY_ADS_REMOVED = "ads_removed"
        const val KEY_FIRST_GAME_DONE = "first_game_done"
        const val KEY_PLUS_PASS_PENDING = "plus_pass_pending"
        const val KEY_DICE_TRIAL_SKIN = "dice_trial_skin"
        const val KEY_DICE_TRIAL_HAT = "dice_trial_hat"
        const val KEY_BANKING_HINT = "banking_hint_shown"
        const val KEY_CAREER_STATS = "career_stats"
    }
}
